import { render, staticRenderFns } from "./HeaderMain.vue?vue&type=template&id=6c20695c&scoped=true&"
import script from "./HeaderMain.vue?vue&type=script&lang=js&"
export * from "./HeaderMain.vue?vue&type=script&lang=js&"
import style0 from "./HeaderMain.vue?vue&type=style&index=0&id=6c20695c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c20695c",
  null
  
)

export default component.exports